import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastState } from '../enums/toast-state.enum';

export interface Toast {
  state: string;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastSubject = new Subject<Toast>();
  toast$ = this.toastSubject.asObservable();

  showToast(state: ToastState, message: string, title = '') {
    this.toastSubject.next({ state, title, message });
  }
}
